import styled from 'styled-components';
import { Box } from 'rebass/styled-components';
import { height } from 'styled-system';

export const WidthWrapper = styled(Box)`
  ${height}
  width: 100%;
  max-width: 1200px;
  margin: 0 auto;
`;
